import {
  List,
  Datagrid,
  ReferenceField,
  UrlField,
  TextField,
  RichTextField,
  DateField,
  NumberField,
  ArrayField,
  SearchInput,
  ReferenceInput,
  TextInput,
  DateTimeInput,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  DateInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  Create,
  Show,
  SimpleShowLayout,
  SingleFieldList,
  ChipField,
  ReferenceArrayField,
  FunctionField,
  useGetOne,
  AutocompleteInput
} from 'react-admin'
import { Paper, Grid, Box, Chip } from '@mui/material'
import { CustomRichTextInput } from '../components/CustomRichTextInput'
import { PaperArrayReferenceInput } from '../components/PaperArrayReferenceInput'
import { PaperArrayReferenceInputWithSearch } from '../components/PaperArrayReferenceInputWithSearch'
import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const CampaignList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <ReferenceInput source="partnerId" reference="partners" />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <ReferenceField source="partnerId" reference="partners" />
      <TextField source="title" />
      <DateField source="startsAt" />
      <DateField source="endsAt" />
      <TextField source="bonusDetails" />
      <NumberField source="hiddenTvl" />
      <NumberField source="baseApr" />
      <NumberField source="bonusApr" />
      <UrlField source="landingUrl" />
      <ArrayField source="contracts">
        <Datagrid>
          <ReferenceField source="networkId" reference="networks" />
          <TextField source="contractAddress" />
          <TextField source="methodName" />
          <TextField source="params" />
          <UrlField source="abiUrl" />
        </Datagrid>
      </ArrayField>
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const CampaignEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="iconUrl" type="url" />
      <TextInput source="title" />
      <TextInput source="description" multiline rows={2} fullWidth />
      <DateTimeInput source="startsAt" />
      <DateTimeInput source="endsAt" />
      <TextInput source="bonusDetails" fullWidth />
      <NumberInput source="hiddenTvl" label="Hidden TVL" />
      <NumberInput source="baseApr" />
      <NumberInput source="bonusApr" />
      <Paper
        sx={{
          p: 3,
          mb: 2,
          backgroundColor: 'background.paper',
          borderRadius: 2,
          border: '2px solid',
          borderColor: 'divider',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <ArrayInput source="aprs" label="APRs">
          <SimpleFormIterator
            sx={{
              '& .RaSimpleFormIterator-line': {
                marginBottom: 2,
                paddingBottom: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-child': {
                  borderBottom: 'none',
                  marginBottom: 0,
                  paddingBottom: 0,
                },
              },
            }}
          >
            <ReferenceInput source="tokenId" reference="tokens" fullWidth>
              <AutocompleteInput
                optionText="name"
                filterToQuery={(searchText) => ({ search: searchText })}
                fullWidth
              />
            </ReferenceInput>
            <NumberInput source="value" />
            <TextInput source="description" multiline rows={3} fullWidth />
          </SimpleFormIterator>
        </ArrayInput>
      </Paper>
      <TextInput source="landingUrl" type="url" />
      <Paper
        sx={{
          p: 3,
          mb: 2,
          backgroundColor: 'background.paper',
          borderRadius: 2,
          border: '2px solid',
          borderColor: 'divider',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <ArrayInput source="notes">
          <SimpleFormIterator>
            <TextInput source="" label="Note" multiline rows={2} />
          </SimpleFormIterator>
        </ArrayInput>
      </Paper>
      <PaperArrayReferenceInput label="Networks" source="networkIds" reference="networks" />
      <PaperArrayReferenceInputWithSearch
        label="Asset Tokens"
        source="assetTokenIds"
        reference="tokens"
      />
      <PaperArrayReferenceInputWithSearch
        label="Reward Tokens"
        source="rewardTokenIds"
        reference="tokens"
      />
      <PaperArrayReferenceInputWithSearch
        label="Protocol Tokens"
        source="protocolTokenIds"
        reference="tokens"
      />
      <ArrayInput source="contracts">
        <SimpleFormIterator>
          <ReferenceInput source="networkId" reference="networks" />
          <TextInput source="contractAddress" />
          <TextInput source="methodName" />
          <TextInput source="params" />
          <TextInput source="abiUrl" type="url" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
)

export const CampaignCreate = () => (
  <Create>
    <SimpleForm>
      <AutoFillFromPartner />
      <ReferenceInput source="partnerId" reference="partners" required />
      <TextInput source="iconUrl" type="url" />
      <TextInput source="landingUrl" type="url" />
      <TextInput source="title" required />
      <TextInput source="description" multiline rows={2} fullWidth />
      <DateTimeInput source="startsAt" required />
      <DateTimeInput source="endsAt" required />
      <TextInput source="bonusDetails" fullWidth />
      <NumberInput source="hiddenTvl" label="Hidden TVL" />
      <NumberInput source="baseApr" />
      <NumberInput source="bonusApr" />
      <Paper
        sx={{
          p: 3,
          mb: 2,
          backgroundColor: 'background.paper',
          borderRadius: 2,
          border: '2px solid',
          borderColor: 'divider',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <ArrayInput source="aprs" label="APRs">
          <SimpleFormIterator
            sx={{
              '& .RaSimpleFormIterator-line': {
                marginBottom: 2,
                paddingBottom: 2,
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-child': {
                  borderBottom: 'none',
                  marginBottom: 0,
                  paddingBottom: 0,
                },
              },
            }}
          >
            <ReferenceInput source="tokenId" reference="tokens" fullWidth>
              <AutocompleteInput
                optionText="name"
                filterToQuery={(searchText) => ({ search: searchText })}
                fullWidth
              />
            </ReferenceInput>
            <NumberInput source="value" />
            <TextInput source="description" multiline rows={3} fullWidth />
          </SimpleFormIterator>
        </ArrayInput>
      </Paper>
      <Paper
        sx={{
          p: 3,
          mb: 2,
          backgroundColor: 'background.paper',
          borderRadius: 2,
          border: '2px solid',
          borderColor: 'divider',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <ArrayInput source="notes">
          <SimpleFormIterator>
            <TextInput source="" label="Note" multiline rows={2} />
          </SimpleFormIterator>
        </ArrayInput>
      </Paper>
      <PaperArrayReferenceInput label="Networks" source="networkIds" reference="networks" />
      <PaperArrayReferenceInputWithSearch
        label="Asset Tokens"
        source="assetTokenIds"
        reference="tokens"
      />
      <PaperArrayReferenceInputWithSearch
        label="Reward Tokens"
        source="rewardTokenIds"
        reference="tokens"
      />
      <PaperArrayReferenceInputWithSearch
        label="Protocol Tokens"
        source="protocolTokenIds"
        reference="tokens"
      />
      <ArrayInput source="contracts">
        <SimpleFormIterator>
          <ReferenceInput source="networkId" reference="networks" />
          <TextInput source="contractAddress" />
          <TextInput source="methodName" />
          <TextInput source="params" />
          <TextInput source="abiUrl" type="url" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
)

const AutoFillFromPartner = () => {
  const { setValue, getValues } = useFormContext()
  const partnerId = useWatch({ name: 'partnerId' })
  const { data: partner } = useGetOne('partners', { id: partnerId }, { enabled: !!partnerId })

  useEffect(() => {
    if (!partner) return

    setValue('iconUrl', partner.logoUrl || '')
    setValue('landingUrl', partner.websiteUrl || '')
    setValue('description', partner.description || '')
  }, [partner, getValues, setValue])

  return null
}

export const CampaignShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="partnerId" reference="partners" />
      <UrlField source="iconUrl" />
      <TextField source="title" />
      <RichTextField source="description" />
      <DateField source="startsAt" />
      <DateField source="endsAt" />
      <TextField source="bonusDetails" />
      <NumberField source="hiddenTvl" label="Hidden TVL" />
      <NumberField source="baseApr" />
      <NumberField source="bonusApr" />
      <ArrayField source="aprs" label="APRs">
        <Datagrid>
          <ReferenceField source="tokenId" reference="tokens" />
          <TextField source="description" />
          <NumberField source="value" />
        </Datagrid>
      </ArrayField>
      <UrlField source="landingUrl" />
      <ArrayField source="notes" label="Notes">
        <SingleFieldList>
          <FunctionField
            render={(record) => {
              // When ArrayField iterates over primitives, the record IS the value
              const value = typeof record === 'string' ? record : String(record || '')
              return <Chip label={value} size="small" />
            }}
          />
        </SingleFieldList>
      </ArrayField>
      <ReferenceArrayField label="Networks" reference="networks" source="networkIds">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ReferenceArrayField label="Asset Tokens" reference="tokens" source="assetTokenIds">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ReferenceArrayField label="Reward Tokens" reference="tokens" source="rewardTokenIds">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ReferenceArrayField label="Protocol Tokens" reference="tokens" source="protocolTokenIds">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ArrayField source="contracts">
        <Datagrid>
          <ReferenceField source="networkId" reference="networks" />
          <TextField source="contractAddress" />
          <TextField source="methodName" />
          <TextField source="params" />
          <UrlField source="abiUrl" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
)
